export default {
  activateLandingPageTitle: 'Wydarzenia',
  activateProductCardTitle: 'Wydarzenia',
  activateProductPageTitle: 'Rezerwuj wydarzenia',
  allProductsLandingPageTitle: 'Rezerwuj wyjątkowe doświadczenia',
  apply: 'Zastosuj',
  buyTickets: 'Kup bilety',
  cancel: 'Anuluj',
  clear: 'Wyczyść',
  clearFilters: 'Wyczyść filtry',
  discoverExperiences: 'Odkryj doświadczenia',
  exclusive: 'Ekskluzywne',
  experience: 'doświadczenie',
  experiencePhotoOfListing:
    'Zdjęcie doświadczenia {{photoNumber}} z oferty {{listingTitle}}',
  experiences: 'doświadczenia',
  filterExperiences: 'Filtruj doświadczenia',
  fromListingCard: 'Od',
  hostedBy: 'Prowadzone przez',
  hostLandingPageTitle: 'Lokalne doświadczenia',
  hostProductCardTitle: 'Lokalne doświadczenia',
  hostProductPageTitle: 'Rezerwuj lokalne doświadczenia',
  landingPageTitle: 'Rezerwuj wyjątkowe doświadczenia',
  mainLandingPageTitle: 'Wszystkie doświadczenia',
  more: 'Więcej',
  noExperiencesFound: 'Nie znaleziono doświadczeń',
  noExperiencesFoundFor: 'Nie znaleziono doświadczeń dla',
  experiencesFoundCount: 'Znaleziono {{count}} doświadczeń',
  profileImageOfHost: 'Zdjęcie profilowe gospodarza {{hostName}}',
  reserve: 'Zarezerwuj',
  reserveLandingPageTitle: 'Aktywności i udogodnienia',
  reserveProductCardTitle: 'Aktywności',
  reserveProductPageTitle: 'Rezerwuj aktywności i udogodnienia',
  resultsPageTitle: 'Rezerwuj doświadczenia i aktywności',
};
